import { useEffect, useState } from 'react';
import {
  fetchCurrentMemberProfile,
  getCurrentUser,
  hasAuthToken,
  resolveSessionUser,
  type OneliveSessionUser,
} from './api';

export function useOneliveSession() {
  const [user, setUser] = useState<OneliveSessionUser | null>(() => getCurrentUser());
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    let mounted = true;

    void resolveSessionUser().then((resolved) => {
      if (!mounted) return;
      setUser(resolved);
      setAuthReady(true);
    });

    const core = (window as { G7Core?: { state?: { subscribe?: (cb: (state: Record<string, unknown>) => void) => () => void } } }).G7Core;
    const unsubscribe = core?.state?.subscribe?.((state) => {
      const global = (state?._global ?? state) as Record<string, unknown>;
      const nextUser = (global?.currentUser ?? null) as OneliveSessionUser | null;
      setUser(nextUser?.uuid ? nextUser : null);
    });

    return () => {
      mounted = false;
      unsubscribe?.();
    };
  }, []);

  useEffect(() => {
    if (!authReady || user?.uuid || !hasAuthToken()) return;

    let mounted = true;
    void fetchCurrentMemberProfile().then((profile) => {
      if (!mounted || !profile?.uuid) return;
      setUser(profile);
    });

    return () => {
      mounted = false;
    };
  }, [authReady, user?.uuid]);

  return {
    user,
    isAuthed: Boolean(user?.uuid),
    authReady,
  };
}
